import { render, staticRenderFns } from "./CitySelect.vue?vue&type=template&id=0a5bea5a&scoped=true&"
import script from "./CitySelect.vue?vue&type=script&lang=js&"
export * from "./CitySelect.vue?vue&type=script&lang=js&"
import style0 from "./CitySelect.vue?vue&type=style&index=0&id=0a5bea5a&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5bea5a",
  null
  
)

export default component.exports